/* eslint-disable react-hooks/exhaustive-deps */
import FormHelperText from '@material-ui/core/FormHelperText'
import Typography from '@material-ui/core/Typography'
import React, { useCallback } from 'react'

import { toolBarPresets } from 'sensory/blackSquirrel/model/primis/Richtext'

import EditorWrapper from './EditorWrapper'

export default function CustomRichText(props) {
  const { label, helperText, disabled, value, onUpdate, onEmptyLinksChange, settings = {} } = props
  const { brand, toolbarPreset } = settings

  const toolbar = toolBarPresets[toolbarPreset] || toolBarPresets.default

  const handleUpdate = useCallback(
    (newValue) => {
      if (disabled || JSON.stringify(value) === JSON.stringify(newValue)) return
      onUpdate && onUpdate(newValue)
    },
    [disabled, onUpdate],
  )

  return (
    <>
      <Typography style={{ fontSize: 11, marginBottom: 2 }}>{label}</Typography>
      <EditorWrapper
        brand={brand}
        content={value}
        editable={!disabled}
        toolbar={toolbar}
        onUpdate={handleUpdate}
        onEmptyLinksChange={onEmptyLinksChange}
      />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </>
  )
}
